import { useState } from 'react'

// Réglages d'une étape. Le vocabulaire reste celui d'un agent, pas d'un
// développeur : « fin du parcours » plutôt que « final », « qui la voit »
// plutôt que « visibility ».
export default function EtapeForm({ etape, catalogue, onEnregistrer, onSupprimer, onAnnuler }) {
  const [e, setE] = useState({ ...etape })
  const maj = (champs) => setE({ ...e, ...champs })

  return (
    <div className="fenetre" role="dialog" aria-label="Réglages de l'étape">
      <div className="fenetre-corps">
        <h2>Réglages de l'étape</h2>

        <div className="champ">
          <label htmlFor="et-label">Nom de l'étape</label>
          <input id="et-label" value={e.label} autoFocus
                 onChange={(ev) => maj({ label: ev.target.value })} />
          <p className="aide">Ce nom est lu par les agents et, si l'étape est visible, par
            l'habitant sur son suivi. Nommez-la comme vous l'annonceriez au téléphone.</p>
        </div>

        <div className="champ">
          <label htmlFor="et-help">À quoi sert cette étape</label>
          <textarea id="et-help" rows={2} value={e.help || ''}
                    placeholder="Une phrase pour l'agent qui découvre le dossier"
                    onChange={(ev) => maj({ help: ev.target.value })} />
        </div>

        <div className="ligne-champs">
          <div className="champ">
            <label htmlFor="et-tone">Couleur</label>
            <select id="et-tone" value={e.tone || 'b'} onChange={(ev) => maj({ tone: ev.target.value })}>
              {catalogue.tones.map((t) => <option key={t.key} value={t.key}>{t.label}</option>)}
            </select>
          </div>
          <div className="champ">
            <label htmlFor="et-final">Fin du parcours</label>
            <select id="et-final" value={e.final ? '1' : '0'}
                    onChange={(ev) => maj({ final: ev.target.value === '1' })}>
              <option value="0">Non, le dossier continue</option>
              <option value="1">Oui, dossier terminé</option>
            </select>
          </div>
        </div>

        <div className="champ">
          <label htmlFor="et-vis">Qui voit cette étape</label>
          <select id="et-vis" value={e.visibility || 'public'}
                  onChange={(ev) => maj({ visibility: ev.target.value })}>
            {catalogue.visibilities.map((v) => <option key={v.key} value={v.key}>{v.label}</option>)}
          </select>
          <p className="aide">Une étape technique gagne à rester interne pour ne pas encombrer
            le suivi de l'habitant.</p>
        </div>

        <div className="ligne separee">
          {onSupprimer && (
            <button className="btn dgr" onClick={() => onSupprimer(e)}>Supprimer l'étape</button>
          )}
          <div className="pousse" />
          <button className="btn" onClick={onAnnuler}>Annuler</button>
          <button className="btn pri" onClick={() => onEnregistrer(e)}>Enregistrer</button>
        </div>
      </div>
    </div>
  )
}
